<template>
  <div class="ws-pagenate-type-b">
    <div class="typing-section">
      <p>前往第</p>
      <WsStateInput
        @keyup.enter="$_onGoingToPageSubmit()"
        v-model="goingToPage"
        small
        center
      ></WsStateInput>
      <p>頁 共{{lastPage}}頁</p>
      <WsBtn
        small
        @click="$_onGoingToPageSubmit()"
      >Go</WsBtn>
    </div>
    <div class="click-section">
      <p>第{{_dataIngStartIndex}}-{{_dataIngEndIndex}}筆 共{{dataTotalCount}}筆</p>
      <div class="click-section-btns">
        <WsIconBtn
          @click="$_pageTo(1)"
          :size="32"
        >mdi-page-first</WsIconBtn>
        <WsIconBtn
          @click="$_pagePrev()"
          :size="32"
        >mdi-chevron-left</WsIconBtn>
        <WsIconBtn
          @click="$_pageNext()"
          :size="32"
        >mdi-chevron-right</WsIconBtn>
        <WsIconBtn
          @click="$_pageTo(lastPage)"
          :size="32"
        >mdi-page-last</WsIconBtn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WsPagenateTypeB",
  data: () => ({
    goingToPage: 1,
  }),
  computed: {
    _dataIngStartIndex() {
      return (this._currentPage - 1) * this.itemsPerPage + 1;
    },
    _dataIngEndIndex() {
      return this._currentPage * this.itemsPerPage > this.dataTotalCount
        ? this.dataTotalCount
        : this._currentPage * this.itemsPerPage;
    },
    _currentPage() {
      return parseInt(this.currentPage);
    },
  },
  props: {
    currentPage: {
      type: [Number, String],
      default: 1,
    },
    lastPage: {
      type: Number,
      default: 1,
    },
    dataTotalCount: Number,
    itemsPerPage: Number,
  },
  methods: {
    $_pagePrev() {
      if (this._currentPage <= 1) {
        return;
      } else {
        this.$emit("pageto", this._currentPage - 1);
      }
    },
    $_pageNext() {
      if (this._currentPage >= this.lastPage) {
        return;
      } else {
        this.$emit("pageto", this._currentPage + 1);
      }
    },
    $_onGoingToPageSubmit() {
      this.$emit("pageto", parseInt(this.goingToPage));
    },
    $_pageTo(page) {
      this.$emit("pageto", page);
    },
  },
  watch: {
    _currentPage: {
      handler() {
        this.goingToPage = this._currentPage;
      },
    },
  },
  mounted() {
    this.goingToPage = this._currentPage;
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-pagenate-type-b.scss";
</style>